import { gql } from '@apollo/client';
import { venueFragment } from '../../../../graphql/fragments';

export const GET_EMPLOYEES = gql`
    query Employees {
        employees {
            id
            pin
            role
            account {
                id
                firstName
                lastName
                email
            }
            venues {
                id
                name
            }
            currentVenue {
                id
                name
            }
        }
    }
`;

export const GET_EMPLOYEE = gql`
     query GetEmployee($id: String!) {
        employee(id: $id) {
            id
            pin
            role
            account {
                id
                firstName
                lastName
                email
            }
            venues {
                id
                name
            }
            currentVenue {
                id
                name
            }
        }
        venues {
            ...VenuesFragment
        }
    }
    ${venueFragment}
`;

export const CreateEmployeeFormQuery = gql`
    query CreateEmployeeFormQuery{
        venues {
            ...VenuesFragment
        }
    }
    ${venueFragment}
`;
